import React, { useContext, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TableSortLabel,
  TextField,
  Chip,
  Tooltip,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import AppContext from "../../Contexts/AppContext";
import AddIcon from "@mui/icons-material/Add";

export function ProductsList({ items, setSelectedItem }) {
  // TODO - Añadir filtros de AOI y categorías por API
  const { t, i18n } = useTranslation("main");
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("title");
  const [filter, setFilter] = useState("");
  const [selectedTag, setSelectedTag] = useState(null);
  const { selectedTags, setSelectedTags } = useContext(AppContext);

  // Función para ordenar por una propiedad dada
  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  // Filtrado por texto y por tag (si se ha seleccionado alguno)
  const filteredItems = items.filter((item) => {
    const textMatch =
      (item.title?.[i18n.language] || "")
        .toLowerCase()
        .includes(filter.toLowerCase()) ||
      (item.category || "").toLowerCase().includes(filter.toLowerCase());
    const tagMatch = selectedTag
      ? item.tags?.some(
          (tagItem) => tagItem.tag && tagItem.uuid === selectedTag
        )
      : true;
    return textMatch && tagMatch;
  });

  // Ordenación simple según la propiedad seleccionada
  const sortedItems = filteredItems.sort((a, b) => {
    let aValue = a[orderBy];
    let bValue = b[orderBy];

    if (orderBy === "title") {
      aValue = a.title?.[i18n.language] || "";
      bValue = b.title?.[i18n.language] || "";
    }
    if (aValue < bValue) {
      return order === "asc" ? -1 : 1;
    }
    if (aValue > bValue) {
      return order === "asc" ? 1 : -1;
    }
    return 0;
  });

  return (
    <Paper sx={{ width: "100%", overflow: "hidden", borderRadius: "1rem" }}>
      {/* Campo de búsqueda para filtrar los elementos */}
      {/* <TextField
        variant="outlined"
        placeholder="Buscar..."
        value={filter}
        onChange={(e) => setFilter(e.target.value)}
        sx={{ margin: 2 }}
      /> */}
      <TableContainer sx={{ maxHeight: "75vh" }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>{t("image")}</TableCell>
              <TableCell sortDirection={orderBy === "title" ? order : false}>
                <TableSortLabel
                  active={orderBy === "title"}
                  direction={orderBy === "title" ? order : "asc"}
                  onClick={() => handleSort("title")}
                >
                  {t("title")}
                </TableSortLabel>
              </TableCell>
              <TableCell sortDirection={orderBy === "category" ? order : false}>
                <TableSortLabel
                  active={orderBy === "category"}
                  direction={orderBy === "category" ? order : "asc"}
                  onClick={() => handleSort("category")}
                >
                  {t("category")}
                </TableSortLabel>
              </TableCell>
              <TableCell>{t("description")}</TableCell>
              <TableCell>{t("tags")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedItems.map((item) => (
              <TableRow
                key={item.uuid}
                hover
                onClick={() => setSelectedItem(item)}
                sx={{ cursor: "pointer" }}
              >
                <TableCell>
                  <img
                    src={
                      item.bg_image_uuid?.url ||
                      `/images/pocs_images/${item.title?.en}.png`
                    }
                    alt={item.title?.[i18n.language]}
                    style={{
                      width: 50,
                      height: 50,
                      objectFit: "cover",
                      borderRadius: "8px",
                    }}
                  />
                </TableCell>
                <TableCell>{item.title?.[i18n.language]}</TableCell>
                <TableCell>
                  <label
                    style={{
                      border: "1px solid black",
                      borderRadius: "1rem",
                      //color: "black",
                      backgroundColor: item.color_bg_1,
                      color: item.color_txt_1,
                      fontWeight: "bold",
                      padding: "0.5rem",
                    }}
                  >
                    {item.category}
                  </label>
                </TableCell>
                <TableCell style={{minWidth:'350px'}}>{item.description_short?.[i18n.language]}</TableCell>
                <TableCell>
                  {item.tags?.map((tag) => {
                    return (
                      <Tooltip title={t("add_tag")}>
                        <Chip
                          key={tag.uuid}
                          label={"# " + tag.tag?.[i18n.language]}
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedTags((curr) => [...curr, tag]);
                          }}
                          onDelete={(e) => {
                            e.stopPropagation();
                            setSelectedTags((curr) => [...curr, tag]);
                          }}
                          sx={{ marginRight: "2px" }}
                          deleteIcon={<AddIcon style={{ color: "inherit" }} />}
                        />
                      </Tooltip>
                    );
                  })}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}
